import { nothing } from 'maybeasy';
import { action, makeObservable, observable } from 'mobx';
import { DeepLinksOptionsResource, State, loading, ready, waiting } from './Types';
import { Link } from '../../../../../../Resource/Types';
import { error } from '../../../../../../ErrorHandling';
import { TPlainTextKey } from '../../../../../../Translations';

class DeepLinksOptionsStore {
  @observable
  state: State = waiting();
  readonly learningCollectionLinks: ReadonlyArray<Link>;

  constructor(learningCollectionLinks: ReadonlyArray<Link>) {
    makeObservable(this);
    this.learningCollectionLinks = learningCollectionLinks;
  }

  @action
  loading = () => {
    switch (this.state.kind) {
      case 'waiting':
        return (this.state = loading());
      case 'loading':
      case 'ready':
      case 'error':
        return nothing();
    }
  };

  @action
  ready = (resource: DeepLinksOptionsResource) => {
    switch (this.state.kind) {
      case 'loading':
        return (this.state = ready(resource));
      case 'ready':
      case 'waiting':
      case 'error':
        return nothing();
    }
  };

  @action
  error = (msg: TPlainTextKey) => {
    this.state = error(msg);
  };
}

export default DeepLinksOptionsStore;
